import { CompassContextType } from '@/src/libs/CompassContext';

import { createUtilityMarker } from './createUtilityMarker';
import { DEFAULT_CENTER } from './initializeMap';

const getGeolocationCenter = async (ctx: CompassContextType) => {
  // try {
  //   const location = await createGeolocationPromise();
  //   setLocation(location.coords.latitude, location.coords.longitude, ctx);
  //   return;
  //   // eslint-disable-next-line
  // } catch (error) {}

  try {
    const ipData = await getIPAPI();
    setLocation(ipData.latitude, ipData.longitude, ctx);
  } catch (error) {
    setLocation(DEFAULT_CENTER.lat, DEFAULT_CENTER.lng, ctx);
    throw new Error('Geolocation disabled. Some features may be limited.');
  }
};

const createGeolocationPromise = () => {
  return new Promise<GeolocationPosition>((resolve, reject) => {
    navigator.geolocation.getCurrentPosition(resolve, reject);
  });
};

const getIPAPI = async () => {
  const response = await fetch('https://ipapi.co/json/');
  const data = await response.json();
  return data;
};

const setLocation = (lat: number, lng: number, ctx: CompassContextType) => {
  ctx.dispatch({
    type: 'ACCEPT_MAP_CENTER',
    payload: {
      lat: lat,
      lng: lng,
    },
  });

  ctx.state.map?.setCenter({
    lat: lat,
    lng: lng,
  });

  createUtilityMarker({ lat, lng }, ctx, 'user');
};

export { createGeolocationPromise, getGeolocationCenter };
